import React from 'react';
import { Database, ExternalLink, Terminal } from 'lucide-react';

const DataAnalyzer = () => {
    return (
        <div className="container section">
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div style={{
                    background: 'white',
                    padding: '3rem',
                    borderRadius: 'var(--radius)',
                    boxShadow: 'var(--shadow)',
                    textAlign: 'center'
                }}>
                    <div style={{
                        background: '#e0f2fe',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 2rem',
                        color: 'var(--secondary)'
                    }}>
                        <Database size={40} />
                    </div>

                    <h1 className="gradient-text" style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
                        Data Analyzer
                    </h1>

                    <p style={{ fontSize: '1.2rem', color: 'var(--text-muted)', marginBottom: '3rem', lineHeight: '1.6' }}>
                        The Data Analyzer is powered by <strong>Apache Superset</strong>, providing enterprise-grade data exploration and visualization capabilities.
                    </p>

                    <div style={{
                        background: '#f8fafc',
                        padding: '2rem',
                        borderRadius: '0.5rem',
                        border: '1px solid var(--border)',
                        marginBottom: '3rem',
                        textAlign: 'left'
                    }}>
                        <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                            <ExternalLink size={20} /> Connection Status
                        </h3>
                        <p style={{ marginBottom: '1rem', color: 'var(--text-muted)' }}>
                            Connected to Apache Superset instance.
                            <br /><br />
                            <strong>Endpoint:</strong> <code>{`http://${window.location.hostname}:8088`}</code>
                        </p>
                    </div>

                    <a
                        href={`http://${window.location.hostname}:8088/superset/welcome`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                        style={{ fontSize: '1.25rem', padding: '1rem 2rem' }}
                    >
                        Launch Superset <ExternalLink size={20} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default DataAnalyzer;
